import { LiFiWidget } from '@lifi/widget';
import { Box, CircularProgress, Grid, Modal, styled } from '@mui/material';
import dynamic from 'next/dynamic';

import { useContractAddress } from '~components/hooks/protocol/useContractAddress';
import { ENativeAsset } from '~config/types';

import { useAccountDial } from '../../provider';

const LiFiWidgetDynamic = dynamic(() => import('@lifi/widget').then(module => module.LiFiWidget) as any, {
  ssr: false,
  loading: () => (
    <Grid container>
      <CircularProgress sx={{ margin: 'auto' }} />
    </Grid>
  ),
}) as typeof LiFiWidget;

const LifiWidgetContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const LifiModal: React.FC = () => {
  const vstaAddress = useContractAddress(ENativeAsset.VSTA);

  const { isLifiWidgetOpen, setIsLifiWidgetOpen } = useAccountDial();

  if (!isLifiWidgetOpen) return null;

  return (
    <Modal
      open={isLifiWidgetOpen}
      onClose={() => {
        setIsLifiWidgetOpen(false);
      }}
      sx={{ zIndex: 1800 }}
    >
      <Box>
        <LifiWidgetContainer>
          <LiFiWidgetDynamic
            config={{
              containerStyle: {
                width: 392,
                height: 640,
                border: `1px solid rgb(234, 234, 234)`,
                borderRadius: '16px',
                display: 'flex',
                maxWidth: 392,
              },
              toChain: 'arb',
              toToken: vstaAddress,
              integrator: 'Vesta Finance',
            }}
          />
        </LifiWidgetContainer>
      </Box>
    </Modal>
  );
};
